export default __webpack_public_path__ + "static/media/wheel-frame.5e502af1.png";